<template>
  <span style="line-height: 0" :style="{ fontSize: size + 'px' }">
    <component :is="selectedIcon" />
  </span>
</template>

<script>
import icons from '../assets/icons'

export default {
  name: "Icon",
  props: ['name', 'size', 'full'],
  computed: {
    selectedIcon() {
      const pack = icons[this.name]
      if (!pack) return null
      return this.full ? pack.full : pack.normal
    }
  }
}
</script>

<style scoped>
svg {
  width: 1em;
  height: 1em;
  fill: currentColor;
}
</style>
